
import lax from 'lax.js';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faTwitter, faDiscord, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { defineComponent, ref, onMounted,onBeforeMount, onBeforeUnmount } from '@nuxtjs/composition-api';

export default defineComponent({
	
	setup(props, ctx) {
		const loaded = ref<boolean>(false);
		const error = ref<boolean>(false);


		
		onMounted(async () => {
			library.add(faTwitter, faYoutube, faDiscord, fas);
			dom.watch();
		});
		

		onBeforeMount(async () => {
			// loaded.value = true;
			
		
		});

		
		return {
			loaded,
			error
		}
	}
})
